import { Component, Injectable, Input } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { AdministrationService } from 'app/services/administration.service';
import { AlertService } from 'app/utils/alert.service';
import { ServiceMember } from 'app/models/serviceMember.model';

/**
 * @author Edivaldo Mascarenhas
 * @version $Id: content.component.ts 79366 2018-02-17 00:40:37Z thiago.h.neri $
 */
 @Component({
  selector:     'removeServiceMemberComponent',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class RemoveServiceMemberComponent {

  @Input() serviceName: string;
  @Input() contractNumber: string;
  @Input() serviceMember: ServiceMember;

  private removing: boolean;
  private info: string;

  constructor(private activeModal: NgbActiveModal, private adminService: AdministrationService, private alertService: AlertService) {

  }

  private close() {
    this.activeModal.dismiss();
  }

  private removeMember(serviceMember: ServiceMember) {
    this.removing = true;
    let payload = { 
      action:   'removeMember',
      serviceMember: this.serviceMember,
      serviceName: this.serviceName,
      contractNumber: this.contractNumber
    }
    this.adminService.removeMember(payload).subscribe(
      data => {
        this.removing = false;
        this.activeModal.close();
        this.alertService.success(data['result']);
      },
      err => {
        this.removing = false;
        this.activeModal.close();
        this.alertService.error(err.result, err);
      }
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/administration/abbreviatedDialing/remove/content.component.ts